// extracted by mini-css-extract-plugin
export default {"images":"ui_images__wxQRt","bg":"ui_bg__QMiBF"};